import axios from 'axios';

import { logError } from 'Utils/errorHandler';
import { BULLETIN_TYPES } from 'Store/constants/sportTypes';
import {
  GET_SPORTSBOOK_TABS_REQUEST,
  GET_SPORTSBOOK_TABS_SUCCESS,
  GET_SPORTSBOOK_TABS_FAILURE,
  GET_SPORTSBOOK_EVENTS_REQUEST,
  GET_SPORTSBOOK_EVENTS_SUCCESS,
  GET_SPORTSBOOK_EVENTS_FAILURE,
  SET_SPORTSBOOK_ACTIVE_FILTERS,
  SPORTSBOOK_FILTER_CLICKED,
  VIEW_EVENT_LIST_MIXPANEL,
  SET_SPORTSBOOK_HEADER_FILTERS,


  GET_PARENT_EVENTS_REQUEST,
  GET_PARENT_EVENTS_SUCCESS,
  GET_PARENT_EVENTS_FAILURE,
  TOGGLE_DUELLO_DETAIL,
  RESET_TOOGLE_DUELLO_DETAIL,
  SET_SPORTS_BOOK_EVENTS_COUNT,
  SET_PREVIEW_FILTERS
} from 'Store/constants';
// import { EVENTS_API_INTERVAL } from 'Utils/timeConstants';
import errorMessage from 'Store/actions/errorMessage';
import { getEventScores } from './eventScoresActions';
import { generateAvailableFilter } from 'Utils/filterGenerator';

export const getSportsBookTabs = () => async dispatch => {
  try {
    dispatch({
      type: GET_SPORTSBOOK_TABS_REQUEST
    });

    const res = await axios.get('/v3/mobile/aggregator/gamelist/all/maintabs/v2');

    const { tabs } = res.data;

    dispatch({
      type: GET_SPORTSBOOK_TABS_SUCCESS,
      payload: { tabs }
    });

  } catch (e) {
    logError(e);

    dispatch({
      type: GET_SPORTSBOOK_TABS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const getSportsBookEventsByTabType = ({ tabType, bulletinType, showLoading = true }) => async (dispatch, getState) => {
  const eventsHash = `${bulletinType}:${tabType}`;

  const activeEventsFromStore = getState().sportsBook.sportsBookEvents[eventsHash];

  const isEventsOutdated = true;//activeEventsFromStore ? getUnixTime(Date.now()) > activeEventsFromStore?.timeStamp + EVENTS_API_INTERVAL : true;
  if (typeof activeEventsFromStore !== 'object' || isEventsOutdated) {
    try {
      dispatch({
        type: GET_SPORTSBOOK_EVENTS_REQUEST,
        payload: { urlHash: eventsHash, showLoading }
      });

      if (tabType !== 998 || bulletinType !== 2 ) { //duello tabi haricinde, diğer tablara istek atıldığında RESET_TOOGLE_DUELLO_DETAIL tetiklenmeli.
        dispatch({
          type: RESET_TOOGLE_DUELLO_DETAIL,
        });
      }

      const gameListUrl = '/v3/mobile/aggregator/gamelist/all';

      const res = await axios.get(gameListUrl, {
        params: {
          tabType,
          bulletinType
        }
      });

      const { tabs = [] } = res.data;

      const availableFilters = generateAvailableFilter([...tabs[0]?.eventGroups || [], ...tabs[0]?.onComingEventGroups || []], tabType);

      dispatch({
        type: GET_SPORTSBOOK_EVENTS_SUCCESS,
        payload: { urlHash: eventsHash, tab: tabs[0], availableFilters: availableFilters }
      });

      const { eventGroups } = tabs[0] || {};
      if (bulletinType === BULLETIN_TYPES.LIVE && eventGroups?.length > 0) {
        const eventList = eventGroups.flatMap(eventGroup => eventGroup.events);
        dispatch(getEventScores(eventList));
      }
    } catch (error) {

      dispatch({
        type: GET_SPORTSBOOK_EVENTS_FAILURE,
        payload: { urlHash: eventsHash }
      });
    }
  }
};

export const setSportsBookActiveFilters = filters => dispatch => {
  try {
    dispatch({
      type: SET_SPORTSBOOK_ACTIVE_FILTERS,
      payload: filters,
    });

  } catch (e) {
    logError(e);
  }
};

export const sportsBookFilterClicked = (filterName, isActive, source) => dispatch => {
  try {
    dispatch({
      type: SPORTSBOOK_FILTER_CLICKED,
      payload: { filterName, isActive, source }
    });

  } catch (e) {
    logError(e);
  }
};

export const viewEventListMixpanel = (activeFilters, activeMarketGroupId, isNewHeader = false, activeGameCount) => dispatch => {
  try {
    dispatch({
      type: VIEW_EVENT_LIST_MIXPANEL,
      payload: { activeFilters, activeMarketGroupId, isNewHeader, activeGameCount },
    });

  } catch (e) {
    logError(e);
  }
};


export const setSportsBookHeaderFilters = payload => dispatch => {
  try {
    dispatch({
      type: SET_SPORTSBOOK_HEADER_FILTERS,
      payload: payload
    });

  } catch (e) {
    logError(e);
  }
};


export const getParentEvents = eventId => async dispatch => {
  try {
    dispatch({
      type: GET_PARENT_EVENTS_REQUEST
    });

    const res = await axios.get(`/v3/mobile/aggregator/gamelist/events/${eventId}/parent`);

    dispatch({
      type: GET_PARENT_EVENTS_SUCCESS,
      payload: {
        events: res.data?.events,
        parentEventId: eventId
      }
    });

  } catch (e) {
    dispatch({
      type: GET_PARENT_EVENTS_FAILURE,
      payload: e.response?.data || errorMessage
    });
  }
};

export const toggleDuelloDetail = (eventId, value) => async dispatch => {
  dispatch({
    type: TOGGLE_DUELLO_DETAIL,
    payload: {
      eventId: eventId,
      value: value
    }
  });
};


export const setSportsBookEventsCount = payload => dispatch => {
  try {
    dispatch({
      type: SET_SPORTS_BOOK_EVENTS_COUNT,
      payload: payload
    });

  } catch (e) {
    logError(e);
  }
};

export const setPreviewFilters = filters => dispatch => {
  try {
    dispatch({
      type: SET_PREVIEW_FILTERS,
      payload: filters
    });

  } catch (e) {
    logError(e);
  }
};
